














































// Importing components
import BaseButton from '@/ui/BaseButton.vue';
import BaseLoadingAnimation from '@/ui/BaseLoadingAnimation.vue';
import BaseSortIcons from '@/ui/BaseSortIcons.vue';
// Importing functions
import {getOrders} from '@/ts/orders/get-orders';

export default {
    name: 'TheTableOrders',
    components: {
        BaseButton,
        BaseSortIcons,
        BaseLoadingAnimation,
    },
    props: {},
    data() {
        return {};
    },
    methods: {
        sort(temp) {
            this.$store.dispatch('setOrderParam', temp.order_param);
            this.$store.dispatch('setSortParam', temp.sort_param);
            this.$store.dispatch('setLoadingOn');
            getOrders().finally(() => {
                this.$store.dispatch('setLoadingOff');
            });
        },
        trackDelivery(id) {
            this.$router.push({ name: 'track-delivery', params: { order_id: id} });
        },
        translateStatus(status) {
            switch (status) {
                case 'PENDING': return 'Приема се';
                case 'ACCEPTED': return 'Приета';
                case 'COOKING': return 'Приготвя се';
                case 'DELIVERING': return 'Доставя се';
                case 'DELIVERED': return 'Получена';
            }
        },
    },
};
